module.exports = __webpack_public_path__ + "static/img/video-icon.3b1e3b21.png";